// VISUELS DES LEÇONS REPS — le contenu écrit un nom de fichier, rien de plus.
//
// Les images vivent sur R2 et non dans /public : l'app mobile rend ses aperçus
// dans une WebView, qui n'a pas accès aux fichiers du site. Sauf qu'une URL de
// bucket fait 88 caractères, et le contenu d'une leçon EST ce que l'apprenant
// lit. Écrite en clair, elle poussait `alt` hors de l'écran dans la leçon qui
// enseigne `<figure>`, et donnait une ligne de 143 caractères à éditer sur un
// téléphone.
//
// La leçon écrit donc `src="lune.jpg"`. Pas de dossier, pas de slash : quand le
// parcours enseigne les images, il n'a encore rien dit d'une arborescence, et un
// slash serait un caractère que l'apprenant ne peut pas lire. C'est aussi la
// forme la plus courte qu'un vrai site puisse écrire.
//
// La résolution ne passe pas par une réécriture du code, mais par une BALISE
// `<base>` posée dans l'en-tête de l'aperçu. Trois conséquences :
//   - le navigateur fait le travail, avec ses propres règles ;
//   - la base vit dans le <head>, donc elle survit au remplacement du corps que
//     fait l'app mobile à chaque frappe — un point où une réécriture manuelle
//     avait déjà laissé disparaître les images ;
//   - le code de l'apprenant n'est jamais réécrit, seulement résolu, ce qui est
//     exactement ce que fait un navigateur devant une vraie page.
//
// Ce module a un miroir mobile : reps-app/src/features/lesson/previewAssets.ts.
// Les deux doivent produire la même base, sinon une leçon montre une image sur
// une plateforme et un cadre vide sur l'autre.

/**
 * Racine des visuels, bucket PUBLIC de l'environnement courant. Le bloc `env:`
 * de next.config.mjs donne le bucket de dev en développement et celui de prod
 * en production ; les images sont posées sur les deux, donc les deux marchent.
 * Le repli couvre les contextes sans build Next (scripts, harnais de lint).
 *
 * Espace de noms PLAT : un nom de fichier est unique tous parcours confondus,
 * comme un slug de leçon. Deux parcours qui illustrent la même idée partagent le
 * fichier au lieu de le dupliquer.
 */
export const REPS_ASSET_BASE =
    (process.env.R2_BUCKET_URL_PUBLIC ||
        "https://pub-e7ad803658b0405c87e1ed9e9c18552b.r2.dev/") + "reps/images/";

/**
 * La balise à poser dans l'en-tête d'un aperçu. `target="_blank"` reste dans la
 * même balise : le bac à sable interdit d'ouvrir une fenêtre, donc rien ne
 * navigue, mais le curseur devient une main au survol et l'apprenant VOIT qu'un
 * lien en est un.
 */
export function baseTag() {
    return `<base href="${REPS_ASSET_BASE}" target="_blank">`;
}
